// src/screens/LoginScreen.web.js - Fixed to prevent form control conflicts
import React, { useState } from 'react';
import { View, StyleSheet, Platform, Alert } from 'react-native';
import { 
  TextInput, 
  Button, 
  Card, 
  Title, 
  Paragraph, 
  ActivityIndicator,
  Text
} from 'react-native-paper';
import { useAuth } from '../context/AuthContext';

const LoginScreenWeb = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth();

  const handleLogin = async () => {
    if (!email.trim() || !password.trim()) {
      if (Platform.OS === 'web') {
        alert('אנא מלא את כל השדות');
      } else {
        Alert.alert('שגיאה', 'אנא מלא את כל השדות');
      }
      return;
    }

    try {
      setLoading(true);
      const result = await login(email.trim(), password);
      
      if (!result.success) {
        if (Platform.OS === 'web') {
          alert(result.error || 'שגיאה בהתחברות');
        } else {
          Alert.alert('שגיאה', result.error || 'שגיאה בהתחברות');
        }
      }
    } catch (error) {
      console.error('Login error:', error);
      if (Platform.OS === 'web') {
        alert('שגיאה בהתחברות למערכת');
      } else {
        Alert.alert('שגיאה', 'שגיאה בהתחברות למערכת');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    if (Platform.OS === 'web' && event.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Card style={styles.card}>
          <Card.Content style={styles.cardContent}>
            {/* Logo/Title */}
            <View style={styles.logoContainer}>
              <Text style={styles.logo}>🍕</Text>
              <Title style={styles.title}>MyPizza OrderHR</Title>
              <Paragraph style={styles.subtitle}>
                כניסה למערכת ניהול הזמנות
              </Paragraph>
            </View>

            {/* Login Form */}
            <View style={styles.form}>
              <TextInput
                label="אימייל"
                value={email}
                onChangeText={setEmail}
                keyboardType="email-address"
                autoCapitalize="none"
                autoCorrect={false}
                style={styles.input}
                mode="outlined"
                disabled={loading}
                onKeyPress={handleKeyPress}
              />

              <TextInput
                label="סיסמה"
                value={password}
                onChangeText={setPassword}
                secureTextEntry={!showPassword}
                style={styles.input}
                mode="outlined"
                disabled={loading}
                right={
                  <TextInput.Icon 
                    icon={showPassword ? "eye-off" : "eye"}
                    onPress={() => setShowPassword(!showPassword)}
                  />
                }
                onKeyPress={handleKeyPress}
              />

              <Button
                mode="contained"
                onPress={handleLogin}
                loading={loading}
                disabled={loading || !email.trim() || !password.trim()}
                style={styles.loginButton}
                contentStyle={styles.loginButtonContent}
                labelStyle={styles.loginButtonLabel}
              >
                {loading ? 'מתחבר...' : 'כניסה'}
              </Button>
            </View>

            {/* Demo Credentials */}
            <View style={styles.demoSection}>
              <Text style={styles.demoTitle}>נתונים לדמו:</Text>
              <Text style={styles.demoText}>📧 demo@mypizza.co.il</Text>
              <Text style={styles.demoText}>🔒 123456</Text>
            </View>
          </Card.Content>
        </Card>
      </View>

      {/* Footer */}
      <View style={styles.footer}>
        <Text style={styles.footerText}>
          MyPizza OrderHR © 2025
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
  },
  content: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  card: {
    width: '100%',
    maxWidth: 400,
    borderRadius: 16,
    elevation: 8,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.1,
    shadowRadius: 8,
  },
  cardContent: {
    padding: 32,
  },
  logoContainer: {
    alignItems: 'center',
    marginBottom: 32,
  },
  logo: {
    fontSize: 48,
    textAlign: 'center',
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#2196F3',
    marginTop: 16,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 16,
    color: '#666',
    textAlign: 'center',
    marginTop: 8,
  },
  form: {
    marginBottom: 24,
  },
  input: {
    marginBottom: 16,
    backgroundColor: '#fff',
  },
  loginButton: {
    marginTop: 8,
    borderRadius: 8,
    backgroundColor: '#2196F3',
  },
  loginButtonContent: {
    height: 48,
  },
  loginButtonLabel: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  demoSection: {
    backgroundColor: '#e3f2fd',
    padding: 16,
    borderRadius: 8,
    borderLeftWidth: 4,
    borderLeftColor: '#2196F3',
  },
  demoTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#1976D2',
    marginBottom: 8,
    textAlign: 'center',
  },
  demoText: {
    fontSize: 13,
    color: '#1976D2',
    textAlign: 'center',
    marginBottom: 2,
  },
  footer: {
    padding: 16,
    alignItems: 'center',
  },
  footerText: {
    fontSize: 12,
    color: '#999',
  },
});

export default LoginScreenWeb;